
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/payment/itp/cancel",
      function () {
        return require("private-next-pages/user/payment/itp/cancel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/payment/itp/cancel"])
      });
    }
  